import servicioBase from '@/services/servicio-base'

const servicio = {}

servicio.metodosPago =  () => {
   console.log('metodosPago')
   return servicioBase.get('/cobranza/general/referenciar-pagos/metodos-pago' )
   .then(r => {
       return r.data
   })
   .catch(error => {
       return error
   })
}
servicio.bancos =  () => {
   console.log('bancos')
   return servicioBase.get('/cobranza/general/referenciar-pagos/bancos' )
   .then(r => {
       return r.data
   })
   .catch(error => {
       return error
   })
}
servicio.guardarReferencia = function(documentos, codBanco) {
   
   return servicioBase.post('cobranza/general/referenciar-pagos/guardar/' + codBanco, documentos)
  .then(r => {
     return r.data;
  })
  .catch(e => {
     return e;
  })
}  

servicio.adeudos =  function(cliente) {
   return servicioBase.post('/cobranza/general/referenciar-pagos/saldos' ,  cliente)
   .then(r => {
       return r.data
   })
   .catch(error => {
       return error
   })
}

servicio.BuscarClienteDifarmer = (textoBuscar,codAgente) => {
    return servicioBase.post('/cobranza/general/buscarclientesDifarmer', {textoBuscar,codAgente})
        .then(r => {
            return r.data
        })
        .catch(err => {
            console.log(err)
        })
}
servicio.obeterAccesoReferenciar =  () => {
    return servicioBase.post('/cobranza/general/referenciar-pagos/obeterAccesoReferenciar' )
    .then(r => {
       return r.data
    })
    .catch(error => {
       return error
    })
}
servicio.guardarComprobrante = (formData,folioCobranza) => {
    console.log("guardarComprobrante")
    return servicioBase.post(`cobranza/general/referenciar-pagos/comprobante/${folioCobranza}`, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(r => {
            return r.data
        })
        .catch(err => {
            console.log(err)
        })
}
servicio.consultarFoliosCobranza = function(fechaInicio, fechaFin, pagina){
    return servicioBase.post('/cobranza/general/referenciar-pagos/consultar-folios', {FechaInicio: fechaInicio,FechaFin: fechaFin, Pagina:pagina})
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicio.imprimirRecibo = function(folio, codAgente){
    return servicioBase.get(`/cobranza/general/referenciar-pagos/imprimir-recibo/${folio}/${codAgente}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}
export default servicio